import React from 'react';
import { Box, Grid, Button, Divider, Typography, Skeleton } from '@mui/material';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import Idea from './Ideas';
// import TopIdea from './TopIdeas';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import { getRandomStr } from '../../helpers';

const Description = () => {
  return (<Grid size={{ xs: 12, sm: 12, md: 12 }} sx={{}}>
    <Box component="div" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', my: 1 }}>
      <Typography variant="body2" component="div" color="#D4D4D4"
        sx={{ fontSize: '.875rem !important', textAlign: 'left', mx: 2 }}
      >
        {"Explore our featured stock ideas and investment opportunities to make informed decisions in today's market."}
      </Typography>
      <Button variant="text" size="small" endIcon={<ChevronRightRoundedIcon />}
        sx={{ textTransform: 'none', boxShadow: 0, alignItems: 'center', fontWeight: 600, color: '#fff', mr: 1, borderRadius: '15px', pl: 2, pr: 1 }}
        href="/stock-ideas"
        component="a"
      >
        View All Stock Ideas
      </Button>
    </Box>
  </Grid>);
};

const StockIdeasAdvertisement = ({ stock_ideas, positionBottom, pageLoading, ad_settings, tab }) => {
  let adSettings = ad_settings && ad_settings !== "" ? (JSON.parse(ad_settings)) : {} || {}
  adSettings = adSettings && Object.keys(adSettings).length > 0 ? adSettings[tab] : []
  const filteredStockIdeas = (() => {
    try {
      if (!Array.isArray(stock_ideas)) { return []; }
      if (!Array.isArray(adSettings)) { return []; }
      const filtered = stock_ideas.filter(idea => {
        if (!idea.slug) throw new Error("Each stock idea should have a slug property");
        return adSettings.includes(idea.slug);
      });
      return filtered.sort((a, b) => adSettings.indexOf(a.slug) - adSettings.indexOf(b.slug));
    } catch (error) {
      console.error("Error filtering stock ideas:", error.message);
      return [];
    }
  })();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
  const [activeStep, setActiveStep] = React.useState(0);
  // const maxSteps = stock_ideas.length;
  const maxSteps = 3;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <>
      {pageLoading ? <Skeleton animation="wave" variant="rounded" sx={{ mt: 1.2, height: { md: 167, sm: 140, xs: 140, }, width: '100%' }} /> :
        <Box component="div" className="idea-wrapper">
          {filteredStockIdeas && filteredStockIdeas.length > 0 ?
            <Box component="div" className="row sum-r stock-ideas"
              sx={{
                backgroundColor: '#1a2849', borderRadius: '12px', mt: { md: 1.2, sm: 1.2, xs: 1.2, }, mb: { md: 1.2, sm: 0, xs: 0, },
                backdropFilter: 'blur(20px) saturate(186%)',
                '-webkit-backdrop-filter': 'blur(20px) saturate(186%)',
                border: '1px solid rgba(255, 255, 255, 0.125)'
              }}>
              {matches ?
                <Box sx={{ flexGrow: 1 }}>
                  <Box>
                    {filteredStockIdeas?.slice(0, 3)?.[activeStep] && (
                      <Idea post={filteredStockIdeas[activeStep]} index={activeStep} spaceEvenly={filteredStockIdeas?.length >= 3} />
                    )}
                  </Box>
                  <MobileStepper
                    sx={{
                      background: 'transparent',
                      '&.MuiMobileStepper-root': { padding: 1.5, alignItems: 'center', justifyContent: 'center' },
                      '& .MuiMobileStepper-dot': { backgroundColor: '#c0c0c07c' },
                      '& .MuiMobileStepper-dotActive': { backgroundColor: '#fff' },
                    }}
                    steps={maxSteps}
                    position="static"
                    activeStep={activeStep}
                  // nextButton={
                  //   <Button
                  //     size="small"
                  //     onClick={handleNext}
                  //     disabled={activeStep === maxSteps - 1}
                  //   >
                  //     Next
                  //     {theme.direction === 'rtl' ? (
                  //       <KeyboardArrowLeft />
                  //     ) : (
                  //       <KeyboardArrowRight />
                  //     )}
                  //   </Button>
                  // }
                  // backButton={
                  //   <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                  //     {theme.direction === 'rtl' ? (
                  //       <KeyboardArrowRight />
                  //     ) : (
                  //       <KeyboardArrowLeft />
                  //     )}
                  //     Back
                  //   </Button>
                  // }
                  />
                </Box> :
                <Grid container columnSpacing={{ xs: 0, sm: 0, md: 0, }}>
                  {filteredStockIdeas && filteredStockIdeas.length > 0 ?
                    <>
                      {/* {positionBottom ? null : <Description />} */}
                      {filteredStockIdeas?.slice(0, 3)?.map((post, index) => <Grid size={{ xs: 12, sm: 12, md: 4 }} sx={{}} key={getRandomStr(3)}> <Idea key={index} post={post} index={index} spaceEvenly={filteredStockIdeas?.length >= 3} /></Grid>)}
                      {/* {positionBottom ? <Description /> : null} */}
                      <Description />
                    </> : null}
                </Grid>}
            </Box> : null}
        </Box>}
    </>
  );
};

export default React.memo(StockIdeasAdvertisement);
